module.exports = __webpack_public_path__ + "img/의료기기.bcfcec89.png";